export const guard = async <T>(callback: () => Promise<T>): Promise<maybe<T>> => {
  try {
    const result = await callback()
    return result
  } catch (e) {
    return null
  }
}
